<template>
    <v-card class="elevation-5 pl-1 pb-4">
        <!-- card title -->
        <v-card-title>
            <h2 class="card__title">
                Ваш баланс:
                <span class="blue_3--text">999.99</span> рублей
            </h2>
        </v-card-title>

        <!-- card body -->
        <v-flex xs12 sm7 md7 lg7>
            <v-card-text class="card__paragraph pt-0">
                Пополните баланс на
                <span class="blue_3--text">200</span> рублей, чтобы продолжить
                пользоваться системой
            </v-card-text>
        </v-flex>

        <!-- card button -->
        <v-card-actions>
            <v-btn
                class="btn ml-2"
                color="indigo_5"
                large
                dark
                to="balance/recharge"
                >Пополнить</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'balanceCard',

    data: () => ({}),
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
